import { GoogleLogin } from "@react-oauth/google";
import { Button, Card, Checkbox, Form, Input, Row, Typography, message, Divider } from "antd";
import React, { useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import { Link, useNavigate } from "react-router-dom";
import { useLocalStorage } from "usehooks-ts";
import { LoginContainer, AppboxLanguageSelect } from "../../components";
import { useTranslation } from "react-i18next";
import HTTPClient from "../../utils/HTTPClient";

const { Text } = Typography;

export default function Register({ }) {
    const [user, setUser] = useLocalStorage("user", null);
    const { t } = useTranslation();

    const navigate = useNavigate();
    useEffect(() => {
        if (user) navigate("/home");
    }, []);

    const isLargeScreen = useMediaQuery({
        query: "(min-width: 771px)",
    });

    const handleRegister = (values) => {
        const { name, surname, email, password, conf_password, privacy, terms } = values;
        if (password !== conf_password) {
            message.error(t("register.password_not_same"));
            return;
        }
        if (!privacy) {
            message.error(t("register.form.privacy.error"));
            return;
        }
        if (!terms) {
            message.error(t("register.form.terms.error"));
            return;
        }

        const payload = {
            name,
            surname,
            email,
            password,
            privacy,
            terms,
            coupon: null, //queryParams.get("coupon") ? queryParams.get("coupon") : coupon,
        };

        HTTPClient.post("/auth/register", payload)
            .then((res) => {
                message.success(t("register.success"));
                navigate("/login");
            })
            .catch((e) => {
                if (e.response.data.detail) {
                    message.error(e.response.data.detail);
                } else {
                    message.error(t("register.error"));
                }
            });
    };

    const handleGoogleLogin = (credentialResponse) => {
        if (credentialResponse) {
            HTTPClient.post("/auth/google", credentialResponse)
                .then(async (res) => {
                    message.success(t("register.success_google"));
                    let response = await HTTPClient.get("/auth/user");

                    const logged_user = {
                        ...response.data.user_data,
                        wallet: response.data.wallet,
                        is_profile_complete: response.data.is_profile_complete,
                    };
                    setUser(logged_user);
                    navigate("/home");
                })
                .catch((e) => {
                    message.error(t("register.error"));
                });
            return;
        }
    };

    return (
        <LoginContainer>
            <Row justify="center" align="middle">
                <h1
                    style={{
                        color: "#fff",
                        font: '"Open Sans", sans-serif"',
                        letterSpacing: "-0.2px",
                        fontSize: "3rem",
                        marginBottom: "0.3em",
                        marginTop: !isLargeScreen ? "0" : "",
                        textAlign: "center",
                    }}>
                    {t("register.title")}
                </h1>
            </Row>
            <Row justify="center" align="middle" style={{ marginBottom: "3.5em" }}>
                <Text
                    style={{
                        color: "#fff",
                        font: '"Open Sans", sans-serif"',
                        letterSpacing: "-0.2px",
                        fontSize: "1.5rem",
                    }}>
                    {t("register.subtitle")}{" "}
                    <Link to={"/login"} style={{ color: "#fff", textDecoration: "underline" }}>
                        {t("register.back_to_login")}{" "}
                    </Link>
                </Text>{" "}
            </Row>
            {/* 
            <Row justify="center" align="middle">
                <Card
                    bodyStyle={{ padding: 0 }}
                    style={{
                        minWidth: isLargeScreen ? "26rem" : "90%",
                        maxWidth: !isLargeScreen ? "90%" : "",
                        padding: "2.25rem 1.75rem 1.25rem 1.75rem",
                        marginBottom: "3rem",
                    }}>
                    <Form
                        validateTrigger="onSubmit"
                        name="basic"
                        onFinish={handleRegister}
                        autoComplete="off"
                        style={{ padding: "0px" }}>
                        <Form.Item
                            name="name"
                            rules={[{ required: true, message: t("register.form.name.error") }]}>
                            <Input
                                placeholder={t("register.form.name.label")}
                                style={{ height: "3rem" }}
                            />
                        </Form.Item>
                        <Form.Item
                            name="surname"
                            rules={[{ required: true, message: t("register.form.surname.error") }]}>
                            <Input
                                placeholder={t("register.form.surname.label")}
                                style={{ height: "3rem" }}
                            />
                        </Form.Item>
                        <Form.Item
                            name="email"
                            rules={[
                                {
                                    type: "email",
                                    required: true,
                                    message: t("register.form.email.error"),
                                },
                            ]}>
                            <Input
                                placeholder={t("register.form.email.label")}
                                style={{ height: "3rem" }}
                            />
                        </Form.Item>
                        <Form.Item
                            name="password"
                            rules={[
                                { required: true, message: t("register.form.password.error") },
                            ]}>
                            <Input.Password
                                placeholder={t("register.form.password.label")}
                                style={{ height: "3rem" }}
                                autoComplete="new-password"
                            />
                        </Form.Item>
                        <Form.Item
                            name="conf_password"
                            rules={[
                                { required: true, message: t("register.form.conf_password.error") },
                            ]}>
                            <Input.Password
                                placeholder={t("register.form.conf_password.label")}
                                style={{ height: "3rem" }}
                            />
                        </Form.Item>
                        <Row>
                            <Form.Item name="privacy" valuePropName="checked">
                                <Checkbox>
                                    {t("register.form.privacy.label")}
                                    <Link to={"/privacy"} target="_blank">
                                        {" "}
                                        {t("register.form.privacy.link")}
                                    </Link>{" "}
                                </Checkbox>
                            </Form.Item>
                            <Form.Item name="terms" valuePropName="checked">
                                <Checkbox>
                                    {t("register.form.terms.label")}
                                    <Link to={"/terms_of_service"} target="_blank">
                                        {" "}
                                        {t("register.form.terms.link")}
                                    </Link>{" "}
                                </Checkbox>
                            </Form.Item>
                        </Row>
                        <Form.Item>
                            <Button
                                htmlType="submit"
                                type="primary"
                                style={{
                                    display: "inline-block",
                                    width: "100%",
                                    height: "3.125rem",
                                    borderRadius: "1.5rem",
                                    color: "#fff",
                                    font: ' 700 0.875rem/0 "Open Sans", sans-serif',
                                    cursor: "pointer",
                                    transition: "all 0.2s",
                                }}>
                                {t("register.call_to_action")}
                            </Button>
                        </Form.Item>
                    </Form>

                    <Row justify="center" align="middle">
                        <GoogleLogin
                            onSuccess={(credentialResponse) => {
                                handleGoogleLogin(credentialResponse);
                            }}
                            onError={() => { }}
                        />
                    </Row>
                    <Row justify="center" align="middle" style={{ marginTop: "10px" }}>
                        <Text
                            style={{
                                font: '"Open Sans", sans-serif"',
                                letterSpacing: "-0.2px",
                            }}>
                            {t("register.subtitle")}{" "}
                            <Link to={"/login"} style={{ textDecoration: "underline" }}>
                                {t("register.back_to_login")}{" "}
                            </Link>
                        </Text>
                    </Row>

                    <Divider />
                    <Row justify="center" align="middle">
                        <AppboxLanguageSelect />
                    </Row>
                </Card>
            </Row> */}
        </LoginContainer>
    );
}
